import { get, post, patch, del } from './client.js';
const base = (wsId) => `/workspaces/${wsId}/price-books`;
export const list        = (wsId)                    => get(base(wsId));
export const create      = (wsId, dto)               => post(base(wsId), dto);
export const update      = (wsId, id, dto)           => patch(`${base(wsId)}/${id}`, dto);
export const remove      = (wsId, id)                => del(`${base(wsId)}/${id}`);
export const getEntries  = (wsId, id)                => get(`${base(wsId)}/${id}/entries`);
export const addEntry    = (wsId, id, dto)           => post(`${base(wsId)}/${id}/entries`, dto);
export const removeEntry = (wsId, id, entryId)       => del(`${base(wsId)}/${id}/entries/${entryId}`);
